'use client';

import { openCart } from '@/features/cart/store/cart';

type SuccessToastProps = {
  title: string;
};

const SuccessToast = ({ title }: SuccessToastProps) => (
  <div className="p-toast-message-text">
    <span className="p-toast-summary">Success</span>
    <div className="p-toast-detail">{`${title} added to cart!`}</div>
    <button
      type="button"
      onClick={openCart}
      style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: 0 }}
    >
      Go to cart
    </button>
  </div>
);

export default SuccessToast;
